const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
const token = match ? match[2] : null;
export const multipartHeaders = {
    'Content-Type': 'multipart/form-data',
    'Authorization': 'bearer ' + token
};
